// extracted by mini-css-extract-plugin
export default {"class":"total-count_class__vC+r5"};